<template>
  <div class="leftColumn" :class="{
    leftColumnExpanded: $store.state.display.leftColumn.isExpanded,
    leftColumnCollapsed: !$store.state.display.leftColumn.isExpanded
  }"
  >
    <LeftColumnTopActionBar />
    <LeftColumnConnectionBar v-show="!isConnected" />

    <div class="searchBar">
      <input v-model="searchKey" placeholder="Sohbetlerde ara">
    </div>

    <transition-group name="flip-list" tag="div" class="transitionContainer">
      <ConversationRow v-for="conversation in filteredConversations" :key="conversationListKey(conversation)" :conversation="conversation" />
    </transition-group>

    <ProfileColumn />
    <StarredMessageRow v-if="$store.state.display.leftColumn.starredMessage.isExpanded" />
    <AddNewConversationColumn />
    <div class="noConversationMessage" v-if="filteredConversations.length === 0">
      Henüz bir sohbetiniz bulunmuyor. Yukarıdaki düğmeyi kullanarak yeni bir
      sohbet başlatabilirsiniz.
    </div>
  </div>
</template>

<script>
import ConversationRow from './conversations/ConversationRow.vue'
import AddNewConversationColumn from './newConversation/AddNewConversationColumn.vue'
import ProfileColumn from './profile/ProfileColumn.vue'
import LeftColumnTopActionBar from './LeftColumnTopActionBar.vue'
import LeftColumnConnectionBar from './LeftColumnConnectionBar.vue'
import {
  messageMixin
} from '@/mixins/messageMixin.js'

const StarredMessageRow = () => import(/* webpackChunkName: "starred-messages" */ './conversations/StarredMessageRow.vue')

export default {
  components: {
    LeftColumnTopActionBar,
    ProfileColumn,
    AddNewConversationColumn,
    ConversationRow,
    LeftColumnConnectionBar,
    StarredMessageRow
  },
  mixins: [messageMixin],
  data () {
    return {
      searchKey: '',
      filteredConvData: []
    }
  },

  computed: {
    filteredConversations () {
      // return this.sortedConversationsComputed
      let filteredConv = this.sortedConversationsComputed.filter(sc => {
        if (this.searchKey === '') {
          return sc
        } else if (sc.isGroupConversation && sc.GroupName.toLocaleLowerCase('tr').includes(this.searchKey.toLocaleLowerCase('tr'))) {
          return sc
        } else if (sc.isChannelConversation && sc.ChannelName && sc.ChannelName.toLocaleLowerCase('tr').includes(this.searchKey.toLocaleLowerCase('tr'))) {
          return sc
        } else if (!sc.isGroupConversation && sc.Contact.VisibleName && sc.Contact.VisibleName.toLocaleLowerCase('tr').includes(this.searchKey.toLocaleLowerCase('tr'))) {
          return sc
        } else {
          return null
        }
      })

      return filteredConv
    },
    isConnected () {
      return this.$store.state.isConnected
    }
  },
  watch: {
    sortedConversationsComputed: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        if (newValue === undefined || newValue === null) {
          
        }else{
          let filteredConv = newValue.filter(sc => {
          if (this.searchKey === '') {
            return sc
          } else if (sc.isGroupConversation && sc.GroupName.toLocaleLowerCase('tr').includes(this.searchKey.toLocaleLowerCase('tr'))) {
            return sc
          } else if (sc.isChannelConversation && sc.ChannelName && sc.ChannelName.toLocaleLowerCase('tr').includes(this.searchKey.toLocaleLowerCase('tr'))) {
            return sc
          } else if (!sc.isGroupConversation && sc.Contact.VisibleName && sc.Contact.VisibleName.toLocaleLowerCase('tr').includes(this.searchKey.toLocaleLowerCase('tr'))) {
            return sc
          } else {
            return null
          }
        })
        this.filteredConvData = filteredConv
        }
        
      }
    }
  },
  methods: {
    conversationListKey (conversation) {
      if (conversation.isChannelConversation || conversation.ChannelID) {
        return 'channel-' + (conversation.ChannelID || conversation.ConversationID)
      }
      if (conversation.isGroupConversation || conversation.GroupID) {
        return 'group-' + (conversation.GroupID || conversation.ConversationID)
      }
      return 'conversation-' + conversation.ConversationID
    }
  }
}

</script>

<style lang="less" scoped>
  .leftColumn {
    height: 100%;
    background-color: rgb(255, 255, 255);
    position: relative;
    overflow: hidden;
    flex-shrink: 0;
    border-right: rgb(223, 223, 223) 1px solid;
  }

  .transitionContainer {
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100% - 118px);
  }

  .leftColumnExpanded {
    width: 30%;
    min-width: 300px;
    transition: width 0.3s;
  }

  .leftColumnCollapsed {
    width: 70px;
    transition: width 0.3s;

    .searchBar {
      >input {
        display: none;
      }
    }
  }

  .noConversationMessage {
    text-align: center;
    padding: 30px;
    padding-top: 100px;
    color: #999999;
  }

  .transitionContainer::-webkit-scrollbar {
    width: 2px;
  }

  .transitionContainer::-webkit-scrollbar-thumb {
    background-color: rgb(155, 155, 155);
  }

  .searchBar {
    padding: 5px;
    background-color: #eaeceb;
    border-bottom: 1px solid rgb(209, 209, 209);
    display: flex;
    height: 40px;
  }

  .searchBar>input {
    border: none;
    flex-grow: 1;
    border-radius: 30px;
    padding: 15px 30px;
  }

  .searchBar>input:focus {
    outline: none;
  }

  .searchBarLeftIcon {
    background-color: white;
    width: 30px;
    height: 30px;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
  }

  .searchBarRightIcon {
    background-color: white;
    width: 30px;
    height: 30px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }

</style>
